import { Star, Sun, Moon, Compass } from "lucide-react";
import React from "react";
const features = [
  {
    icon: Star,
    title: "Personalized Horoscopes",
    description:
      "Daily, weekly, and monthly forecasts tailored to your unique astrological profile.",
  },
  {
    icon: Sun,
    title: "Zodiac Compatibility",
    description:
      "Discover your ideal matches in love, friendship, and business relationships.",
  },
  {
    icon: Moon,
    title: "Lunar Phase Guidance",
    description:
      "Align your actions with the moon's energy for optimal success and growth.",
  },
  {
    icon: Compass,
    title: "Life Path Numerology",
    description:
      "Uncover your life's purpose and potential through the power of numbers.",
  },
];

export default function Features() {
  return (
    <section id="features" className="py-20 bg-indigo-50">
      <div className="container mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-indigo-900">
          Cosmic Insights Await You
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 border border-indigo-100"
            >
              <div className="bg-indigo-100 rounded-full w-16 h-16 flex items-center justify-center mb-4">
                <feature.icon className="w-8 h-8 text-indigo-600" />
              </div>
              <h3 className="text-xl font-semibold mb-2 text-indigo-900">
                {feature.title}
              </h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
